import { graphql } from "api/cms-website/generated";

export const MainBannerFragment = graphql(/* GraphQL */ `
    fragment MainBannerFragment on ComponentComponentsMainBanner {
        id
        noMarginBottom
        mainBannerTitle: title
        mainBannerText: text
        subtitle
        mainBannerCta: cta {
            ...ButtonFragment
        }
        image {
            ...ResponsiveImageFragment
        }
        mainBannerAdvantages: advantages {
            ...MainBannerAdvantageFragment
        }
        slogans {
            ...TextFragment
        }
        mainBannerInvisalign: invisalign
        forceNoExtraContent
    }
`);
